"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundRedemptInitRequest = void 0;
var FundRedemptInitRequest = /** @class */ (function () {
    function FundRedemptInitRequest() {
    }
    return FundRedemptInitRequest;
}());
exports.FundRedemptInitRequest = FundRedemptInitRequest;
;
//# sourceMappingURL=fundRedemptInit.request.js.map